<template>
  <span v-if="label !== '—'" class="sa-type-badge" :class="variantClass">{{ label }}</span>
  <span v-else class="sa-type-badge sa-type-badge--empty">—</span>
</template>

<script>
import { businessName } from '@/utils/superAdmin/formatters';

export default {
  name: 'CompanyTypeBadge',
  props: {
    row: { type: Object, required: true },
  },
  computed: {
    label() {
      return businessName(this.row);
    },
    variantClass() {
      if (Number(this.row.typeBusiness) === 1) return 'sa-type-badge--escolar';
      if (Number(this.row.typeBusiness) === 2) return 'sa-type-badge--corp';
      return '';
    },
  },
};
</script>

<style scoped>
.sa-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.45rem;
  border-radius: 6px;
  font-size: 0.6875rem;
  font-weight: 600;
  white-space: nowrap;
}

.sa-type-badge--escolar {
  background: #eef2ff;
  color: #4338ca;
}

.sa-type-badge--corp {
  background: #f5f3ff;
  color: #6d28d9;
}

.sa-type-badge--empty {
  background: transparent;
  color: var(--dashboard-muted, #697386);
  padding: 0;
}
</style>
